"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ChartCard = ({ title, subTitle, children }) => {
    const [text, setText] = (0, react_1.useState)(title.substring(0, 50));
    const [subText, setSubText] = (0, react_1.useState)(subTitle.substring(0, 80));
    return (react_1.default.createElement("div", { className: "relative box-border w-full px-3 md:w-1/2 xl:w-1/3 hover:cursor-pointer", onMouseEnter: () => {
            setText(title);
            setSubText(subTitle);
        }, onMouseLeave: () => {
            setText(title.substring(0, 50));
            setSubText(subTitle.substring(0, 80));
        } },
        react_1.default.createElement("div", { className: "relative mb-5 mt-8 flex min-w-0 flex-col break-words text-center" },
            react_1.default.createElement("div", { className: "min-h-[1px] flex-auto p-0" },
                react_1.default.createElement("h3", { className: "font-sans text-xl font-bold text-neutral-600" }, text),
                react_1.default.createElement("div", { className: "my-8 flex h-full w-full items-center justify-center text-center" }, children),
                react_1.default.createElement("p", { className: "mt-0 mb-3 leading-loose text-sm text-neutral-600" }, subText)))));
};
exports.default = ChartCard;
